import { render, staticRenderFns } from "./CouponLeads.vue?vue&type=template&id=7be13f22"
import script from "./CouponLeads.vue?vue&type=script&lang=js"
export * from "./CouponLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports